import { css, styled } from 'styled-components'

export const MenuWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`
export const MenuBody = styled.div`
  flex: 1;
  flex-direction: row;
  display: flex;
  overflow: hidden;
`
export const MenuFooter = styled.div`
  display: flex;
  background-color: ${props => props.theme.color.white};
  flex: 0.2;
  max-height: 200px;
  padding: 20px 30px;
  flex-direction: row;
  align-items: center;
  color: ${props => props.theme.color.black};

  ${props =>
    props.theme.colorScheme === 'LIGHT' &&
    css`
      border-top: 1px solid ${props.theme.color.line};
    `};
`
export const MenuSummary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: auto;
  padding: 0 30px;
`

export const MenuSummaryTitle = styled.h2`
  font-family: ${props => props.theme.font.secondary};
  color: ${props => props.theme.color.black};
  font-size: 24px;
  margin-bottom: 0;
`
export const MenuSummaryValue = styled.h3`
  font-family: ${props => props.theme.font.primary};
  font-weight: 600;
  color: ${props => props.theme.color.primary};
  font-size: 42px;
  line-height: 52px;
  margin-bottom: 0;
`

export const MenuSidebar = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0.15;
  width: 20%;
  max-width: 20%;
  padding: 10px;
  overflow: auto;
`
export const MenuSeparator = styled.div`
  width: 1px;
  background-color: ${props => props.theme.color.line};
`

export const MenuContent = styled.div`
  flex: 0.85;
  max-width: 80%;
  overflow: auto;
`

export const MenuGrid = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 30px 30px;
`
